/**
 * Barrel export para componentes UI
 * Centraliza imports de todos os componentes base
 */

export { Button } from "./Button";
export type { ButtonProps } from "./Button";

export { Input, Textarea } from "./Input";
export type { InputProps, TextareaProps } from "./Input";

export { Select } from "./Select";
export type { SelectProps } from "./Select";

export { Switch } from "./Switch";
export type { SwitchProps } from "./Switch";

export { Card } from "./Card";
export type { CardProps } from "./Card";

export { PageHeader } from "./PageHeader";
export type { PageHeaderProps } from "./PageHeader";

export { AdminBottomActionBar } from "./AdminBottomActionBar";
export type { AdminBottomActionBarProps } from "./AdminBottomActionBar";

export { MetricCard } from "./MetricCard";
export type { MetricCardProps } from "./MetricCard";

export { SectionCard } from "./SectionCard";
export type { SectionCardProps } from "./SectionCard";

export { Alert } from "./Alert";
export type { AlertProps } from "./Alert";

export { Badge } from "./Badge";
export type { BadgeProps } from "./Badge";

export { EmptyState } from "./EmptyState";
export type { EmptyStateProps } from "./EmptyState";

export { LoadingScreen, LoadingInline } from "./LoadingScreen";
export { Skeleton } from "./Skeleton";
export {
  ToastProvider,
  useFeedbackState,
  useOptionalToast,
  useToast,
} from "./ToastProvider";
export type {
  ToastAction,
  ToastContent,
  ToastKind,
  ToastOptions,
  ToastPromiseMessages,
} from "./ToastProvider";
export { ConfirmDialog } from "./ConfirmDialog";
export type { ConfirmDialogProps, ConfirmDialogTone } from "./ConfirmDialog";
export { useDialogFocusTrap } from "./useDialogFocusTrap";
export { ResultDialog } from "./ResultDialog";
export type {
  ResultDialogAction,
  ResultDialogProps,
  ResultDialogTone,
} from "./ResultDialog";

export { default as OfflineOverlay } from "./OfflineOverlay";
